import React from "react";

const LoadingPane = () => (
  <div className="wrapper-spinner d-flex align-items-center justify-content-center">
    <div className="spinner-border spinner-border-sm" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default LoadingPane;
